module.exports = __webpack_public_path__ + "img/next-expo.6a25172a.svg";